<template lang="html">
  <modal ref="modal" hide-close title="Welcome to your Draft Board">
    <div class="draft-help">
      <p>
        This is the board you will put up on your TV during the draft.
        The commissioner will have access to a panel accessible by the menu in the top left.
      </p>

      <p>
        Here the commissioner can do things like start the draft, pause the draft,
        undo pick, make picks for teams and put the draft into full screen mode.
      </p>

      <p>The back arrow will take you back to settings and the X will close the panel.</p>

      <br />

      <button type="button" @click="getStarted">Let's get started</button>
    </div>
  </modal>
</template>

<script>
export default {
  methods: {
    open() {
      this.$refs.modal.open();
    },

    getStarted() {
      this.$refs.modal.close();
    },
  },
};
</script>
